export type PanelTone = 'brand' | 'emerald' | 'rose' | 'amber' | 'zinc';

export interface ToneStyle {
  /** Panel/tile background tint. */
  bg: string;
  border: string;
  /** Heading/accent text color. */
  text: string;
  /** Icon circle background + border. */
  iconBg: string;
  /** Decorative corner-glow color (paired with `blur-2xl`). */
  glow: string;
}

export const TONE_STYLES: Record<PanelTone, ToneStyle> = {
  brand: {
    bg: 'bg-brand-50 dark:bg-brand-500/5',
    border: 'border-brand-100 dark:border-brand-500/10',
    text: 'text-brand-600 dark:text-brand-400',
    iconBg: 'bg-brand-500/10 dark:bg-brand-500/20 border border-brand-200 dark:border-brand-500/20',
    glow: 'bg-brand-500/10 group-hover:bg-brand-500/20',
  },
  emerald: {
    bg: 'bg-emerald-50 dark:bg-emerald-500/5',
    border: 'border-emerald-100 dark:border-emerald-500/10',
    text: 'text-emerald-600 dark:text-emerald-400',
    iconBg:
      'bg-emerald-500/10 dark:bg-emerald-500/20 border border-emerald-200 dark:border-emerald-500/20',
    glow: 'bg-emerald-500/10 group-hover:bg-emerald-500/20',
  },
  rose: {
    bg: 'bg-rose-50 dark:bg-rose-500/5',
    border: 'border-rose-100 dark:border-rose-500/10',
    text: 'text-rose-600 dark:text-rose-400',
    iconBg: 'bg-rose-500/10 dark:bg-rose-500/20 border border-rose-200 dark:border-rose-500/20',
    glow: 'bg-rose-500/10 group-hover:bg-rose-500/20',
  },
  amber: {
    bg: 'bg-amber-50 dark:bg-amber-500/5',
    border: 'border-amber-100 dark:border-amber-500/10',
    text: 'text-amber-600 dark:text-amber-400',
    iconBg: 'bg-amber-500/10 dark:bg-amber-500/20 border border-amber-200 dark:border-amber-500/20',
    glow: 'bg-amber-500/10 group-hover:bg-amber-500/20',
  },
  zinc: {
    bg: 'bg-zinc-50 dark:bg-zinc-900/30',
    border: 'border-zinc-200 dark:border-white/5',
    text: 'text-zinc-600 dark:text-zinc-300',
    iconBg: 'bg-zinc-100 dark:bg-zinc-800 border border-zinc-200 dark:border-white/5',
    glow: 'bg-zinc-500/5 group-hover:bg-zinc-500/10',
  },
};
